export default {
  importantDecisionsPath: () => 'https://bundleloan.com/blog/the-six-most-important-home-buying-decisions/',
  requestDemoPath: () => 'https://calendly.com/eric-mager/30min',
};



// WEBPACK FOOTER //
// ./src/routes/externalRoutes.js